module.exports = __webpack_public_path__ + "assets/img/img-hotel-01.1ac42368.jpg";